// extracted by mini-css-extract-plugin
module.exports = {"navbar":"core__navbar___1nCOr","container-fluid":"core__container-fluid___3uJDO","container":"core__container___1jIYt"};